import { create } from "zustand";

export const useDeleteConfirmationStore = create((set) => ({
  openModal: false,
  setOpenModal: (val) => set({ openModal: val }),
}));
